import { useEffect } from "react";

const ReportV2 = () => {
  useEffect(() => {
    location.replace(
      "https://open-res.biogeom.com/geoflow-v2/technical-report.pdf"
    );
  }, []);
  return <></>;
};

export default ReportV2;
